import styled from 'styled-components'
import { PageNavItemUnstyled } from './unstyled'

export const PageNavItem = styled(PageNavItemUnstyled)`
  margin: 0px 0px 0px 25px;
  &:hover,
  &.active {
    border-bottom: 2px solid ${props => props.theme.colors.primary} !important;
    height: 59px !important;

    &.disabled {
      border: none !important;
      a {
        color: #8a96a0 !important;
      }
    }

    & > a {
      border: none !important;
      background-color: transparent !important;
      color: ${props => props.theme.colors.secondary} !important;

      &:hover,
      &:focus {
        background-color: transparent !important;
        border: none !important;
      }
    }
  }

  & > a {
    font-size: ${props => props.theme.fontSizes.city.headerNav} !important;
    color: ${props => props.theme.colors.regentGray2} !important;
    line-height: 60px !important;
    border: none !important;
    padding: 0 !important;
  }
`
